// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3af8c2f5","741":"32272e92"}[chunkId] + ".chunk.js";
};